import { useQuery } from "@apollo/client";
import { Box, CircularProgress } from "@mui/material";
import { ReactElement } from "react";

import {
  GetSubaccountShortcodeQuery,
  GetSubscriberSummaryQuery,
  GetSubscriberSummaryQueryVariables,
} from "~frontend/__generated__/graphql";
import { FlexBox } from "~frontend/components/FlexBox";
import { GET_SUBSCRIBER_SUMMARY } from "~frontend/graphql/shortcode";
import { plural } from "~frontend/util/plural";

export function AudienceSummary({
  shortcode,
}: {
  shortcode: GetSubaccountShortcodeQuery["getSubaccount"]["shortcode"];
}): ReactElement {
  const summaryQuery = useQuery<
    GetSubscriberSummaryQuery,
    GetSubscriberSummaryQueryVariables
  >(GET_SUBSCRIBER_SUMMARY, {
    variables: {
      input: {
        shortcodeId: shortcode!.id,
      },
    },
    fetchPolicy: "network-only",
  });

  if (summaryQuery.loading) {
    return (
      <>
        <CircularProgress size={16} />
        Loading subscriber summary...
      </>
    );
  }

  if (summaryQuery.error) {
    return <>Error loading subscriber summary</>;
  }

  return (
    <FlexBox gap={2} alignItems="center">
      <Box sx={{ fontSize: "12px" }}>
        {plural(
          summaryQuery.data!.getSubscriberSummary.activeSubscribers,
          "Contact",
          "Contacts"
        )}
      </Box>
      <Box sx={{ fontSize: "12px" }}>
        {plural(
          summaryQuery.data!.getSubscriberSummary.unsubscribedSubscribers,
          "Opted Out Contact",
          "Opted Out Contacts"
        )}
      </Box>
    </FlexBox>
  );
}
